import { PATH } from '@constants';
import { Box, LinearProgress, Stack, Typography, Link } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import React from 'react';
import { generatePath, Link as RouterLink } from 'react-router-dom';
import { Cronograma, Materia } from './curso.types';

function TabCronograma({
  cronogramas,
  cursoId,
}: {
  cronogramas: Cronograma[] | undefined;
  cursoId: string;
}) {
  return (
    <Grid
      container
      overflow="auto"
      maxHeight="100%"
      pr={4}
      sx={(theme) => ({
        ...(theme.palette.mode === 'dark'
          ? theme.gradients.black
          : theme.gradients.gradient3),
      })}
    >
      {cronogramas?.map((cronograma) => (
        <Grid
          key={cronograma.id}
          position="relative"
          p={0}
          xs={12}
          sm={4}
          sx={(theme) => theme.cursoAulasList.card.container}
        >
          <CronogramaCard {...{ cronograma, cursoId }} />
        </Grid>
      ))}
    </Grid>
  );
}

function CronogramaCard({
  cronograma,
  cursoId,
}: {
  cronograma: Materia;
  cursoId: string;
}) {
  const percentage = React.useMemo(() => {
    if (!cronograma.qtdConteudos) {
      return 0;
    }
    const conteudosVistos =
      cronograma.conteudosVistos > cronograma.qtdConteudos
        ? cronograma.qtdConteudos
        : cronograma.conteudosVistos;
    return (conteudosVistos / cronograma.qtdConteudos) * 100;
  }, [cronograma]);

  return (
    <Link
      component={RouterLink}
      underline="none"
      color="inherit"
      to={generatePath(PATH.cronograma, {
        cursoId,
        cronogramaId: cronograma.id,
      })}
    >
      <Box
        display="flex"
        flexDirection="column"
        textAlign="center"
        px={2}
        py={4.5}
        flex="1"
        overflow="hidden"
        boxSizing="border-box"
      >
        <Typography
          variant="h4"
          sx={(theme) => theme.cursoAulasList.card.title}
        >
          {cronograma.nome}
        </Typography>
        <Stack
          direction="row"
          mt={1.5}
          width="100%"
          alignItems="center"
          spacing={0.5}
        >
          <Typography
            variant="h6"
            sx={(theme) => theme.cursoAulasList.card.progressText}
          >{`${cronograma.qtdConteudos} vídeos`}</Typography>
          <Box flex="1 1 auto">
            <LinearProgress variant="determinate" value={percentage} />
          </Box>
          <Typography
            variant="h6"
            sx={(theme) => theme.cursoAulasList.card.progressText}
          >
            {percentage.toFixed()}%
          </Typography>
        </Stack>
      </Box>
    </Link>
  );
}

export default TabCronograma;
